import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './AdminApp';
import LegalPages from './LegalPages';
import SeoFestivalPages from './SeoFestivalPages';

const path = window.location.pathname.replace(/\/index\.html$/, '').replace(/\/$/, '') || '/';

const LEGAL_PATHS = ['/privacy', '/contact', '/sources'];
const isFestivalSeoPath = path === '/festivals' || path.startsWith('/festivals/');
const RootApp = path === '/admin'
  ? AdminApp
  : isFestivalSeoPath
  ? SeoFestivalPages
  : LEGAL_PATHS.includes(path)
  ? LegalPages
  : App;

if (path === '/admin' || LEGAL_PATHS.includes(path) || isFestivalSeoPath) {
  document.documentElement.classList.add('admin-root');
  document.body.classList.add('admin-root');
}

const container = document.getElementById('root');
const appNode = (
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, appNode);
} else {
  const root = createRoot(container);
  root.render(appNode);
}
